import { useMemo } from "react";

import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `HeaderRoot`,
  item: `HeaderItem`
};

export function useHeaderStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          padding: `0 0 0 24px`,
          overflow: `hidden`
        }
      ],
      item: [
        classNames.item,
        {
          textAlign: `center`,
          width: `100%`,
          selectors: {
            ":first-child": {
              textAlign: `left`
            }
          }
        }
      ]
    }),
    []
  );
}
